<script setup lang="ts">
import { computed } from "vue";

import type { StickyChange } from "@/model/change";

import { useStickyChangeEnlarge } from "../internal/useStickyChangeEnlarge";
import ListItemStickyDiffs from "./ListItemStickyDiffs.vue";
import { groupBySticky } from "./groupChanges";

const props = defineProps<{ changes: StickyChange[] }>();

const changesBySticky = computed(() => groupBySticky(props.changes));

const { expandedItemId, handleExpanded } = useStickyChangeEnlarge();
</script>

<template>
  <div class="diffs-by-sticky">
    <ListItemStickyDiffs
      v-for="change in changesBySticky"
      :key="change.id"
      :change
      :expanded="expandedItemId === change.id"
      @expanded="(opened) => handleExpanded(opened, change.id)"
    />
  </div>
</template>
